import { getWorkflowStatistics, getWorkflowStatisticsp2p } from "../ApiCalls/mantisFlowsManangment";
import { getWorkflowResults } from "../ApiCalls/mantisFlowsManangment";

export const getStatsPayload = async (clientId, workflowId, mantisBusinessUserId) => {
  try {
    // Obtener estadísticas del flujo
    let statsResponse;
    const user_id = mantisBusinessUserId;
    if ( user_id === "67f3f66b52bb5c93527c1542" || user_id === "682b910ca728c4cd1996e3d2" || user_id === "6824470343029ff9bb1b72d4") {
      statsResponse = await getWorkflowStatisticsp2p(clientId, workflowId);
    } else {
      statsResponse = await getWorkflowStatistics(clientId, workflowId);
    }
    
    // Obtener resultados del flujo para extraer un ejemplo de columnas
    const resultsResponse = await getWorkflowResults(clientId, workflowId, mantisBusinessUserId);
    
    // Formatear las estadísticas
    let currentStats = [];
    if (statsResponse.success && statsResponse.data && statsResponse.data.length > 0) {
      // Si hay datos en la respuesta, extraer las estadísticas formateadas
      if (statsResponse.data[0].data && Array.isArray(statsResponse.data[0].data)) {
        currentStats = statsResponse.data[0].data.map(stat => ({
          id: stat.id,
          name: stat.name,
          icon: stat.icon || 'bar-chart-2',
          value: stat.value || 'No disponible'
        }));
      }
    }
    
    // Extraer un ejemplo de columnas del primer registro
    let columnsExample = {};
    if (resultsResponse.success && resultsResponse.data && 
        Array.isArray(resultsResponse.data) && resultsResponse.data.length > 0) {
      // Tomar solo el primer registro como ejemplo
      const firstRecord = resultsResponse.data[0];
      
      // Crear un objeto con los nombres de columnas y sus valores de ejemplo
      if (firstRecord) {
        Object.keys(firstRecord).forEach(key => {
          columnsExample[key] = firstRecord[key];
        });
      }
    }
    
    return {
      success: true,
      currentStats,
      columnsExample
    };
  } catch (error) {
    console.error("Error al obtener datos para el análisis de estadísticas:", error);
    return {
      success: false,
      error: error.message || "Error al obtener datos para el análisis",
      currentStats: [],
      columnsExample: {}
    };
  }
};
